import { LINK_TITLE_LOADING_EVENT } from './config'
import { checkPlatformLink, fetchLinkTitle } from './helpers'

const getLinkHref = (linkEl: CKEDITOR.dom.element) => {
  return (
    linkEl.getAttribute('data-cke-saved-href') || linkEl.getAttribute('href')
  )
}

const getUntitledPlatformLinks = (editor: CKEDITOR.editor) => {
  return (
    editor.editable().find('a').toArray() as CKEDITOR.dom.element[]
  ).filter((linkEl) => {
    return (
      !linkEl.getAttribute('title') && checkPlatformLink(getLinkHref(linkEl))
    )
  })
}

export const linkTitlePlugin: CKEDITOR.pluginDefinition = {
  init: (editor) => {
    const linkTitles = new Map<string, string>()
    const requestedHrefs = new Set<string>()

    let isDestroyed = false
    let requestsCount = 0

    const applyLinkTitles = () => {
      let hasChanges = false

      getUntitledPlatformLinks(editor).forEach((linkEl) => {
        const title = linkTitles.get(getLinkHref(linkEl) || '')

        if (!title) {
          return
        }

        linkEl.setAttribute('title', title)
        hasChanges = true
      })

      if (hasChanges) {
        editor.fire('change')
      }
    }

    const requestLinkTitles = async (hrefs: string[]) => {
      hrefs.forEach((href) => requestedHrefs.add(href))

      requestsCount += 1
      editor.fire(LINK_TITLE_LOADING_EVENT, { isLoading: true })

      const titles = await Promise.all(hrefs.map(fetchLinkTitle))

      requestsCount -= 1

      if (isDestroyed) {
        return
      }

      hrefs.forEach((href, index) => {
        linkTitles.set(href, titles[index])
      })

      applyLinkTitles()

      editor.fire(LINK_TITLE_LOADING_EVENT, {
        isLoading: requestsCount > 0,
      })
    }

    editor.on('change', () => {
      applyLinkTitles()

      const hrefs = new Set<string>()

      getUntitledPlatformLinks(editor).forEach((linkEl) => {
        const href = getLinkHref(linkEl)

        if (href && !requestedHrefs.has(href)) {
          hrefs.add(href)
        }
      })

      if (hrefs.size > 0) {
        requestLinkTitles(Array.from(hrefs))
      }
    })

    editor.on('destroy', () => {
      isDestroyed = true
    })
  },
}
